export const IS_LOADING_GET_TYPE_OF_REPORT = "IS_LOADING_GET_TYPE_OF_REPORT"
export const GET_TYPE_OF_REPORT = "GET_TYPE_OF_REPORT"
export const EDIT_TYPE_OF_REPORT = "EDIT_TYPE_OF_REPORT"
export const IS_LOADING_CREATE_TYPE_OF_REPORT = "IS_LOADING_CREATE_TYPE_OF_REPORT"
export const CREATE_TYPE_OF_REPORT = "CREATE_TYPE_OF_REPORT"
export const IS_LOADING_TYPE_OF_REPORT = "IS_LOADING_TYPE_OF_REPORT"
export const TYPE_OF_REPORT = "TYPE_OF_REPORT"
export const DELETE_REPORT = "DELETE_REPORT"
export const IS_LOADING_ONE_TYPE_OF_REPORT = "IS_LOADING_ONE_TYPE_OF_REPORT"


export const IS_LOADING_CREATE_TYPE_OF_LANDING = "IS_LOADING_CREATE_TYPE_OF_LANDING"
export const CREATE_TYPE_OF_LANDING = "CREATE_TYPE_OF_LANDING"
export const IS_LOADING_LANDINGS = "IS_LOADING_LANDINGS"
export const EDIT_TYPE_OF_LANDING = "EDIT_TYPE_OF_LANDING"
export const LIST_OF_LANDING = "LIST_OF_LANDING"
export const DATA_OF_LANDING = "DATA_OF_LANDING"
export const DELETE_LANDING = "DELETE_LANDING"
export const DEFAULT_LANDING = "DEFAULT_LANDING"

export const GET_LIMIT_REPORTS = "GET_LIMIT_REPORTS"
export const IS_LOADING_GET_LIMIT_REPORTS = "IS_LOADING_GET_LIMIT_REPORTS"
export const DELETE_LIMIT_REPORT = "DELETE_LIMIT_REPORT"
export const GET_LIMIT_REPORT = "GET_LIMIT_REPORT"

export const IS_LOADING_GET_LIST_SKILLS = "IS_LOADING_GET_LIST_SKILLS"
export const GET_LIST_SKILLS = "GET_LIST_SKILLS"
export const ADD_SKILL = "ADD_SKILL"
export const EDIT_SKILL = "EDIT_SKILL"
export const DELETE_SKILL = "DELETE_SKILL"
export const GET_SKILL = "GET_SKILL"

export const GET_LIST_TO_CERTIFICATE = "GET_LIST_TO_CERTIFICATE"
export const ADD_CLASS_CERTIFICATE = "ADD_CLASS_CERTIFICATE"
export const EDIT_CLASS_CERTIFICATE = "EDIT_CLASS_CERTIFICATE"
export const IS_LOADING_GET_LIST_CLASS_CERTIFICATE = "IS_LOADING_GET_LIST_CLASS_CERTIFICATE"
export const GET_LIST_CLASS_CERTIFICATE = "GET_LIST_CLASS_CERTIFICATE"
export const DELETE_CLASS_CERTIFICATE = "DELETE_CLASS_CERTIFICATE"
export const GET_CLASS_CERTIFICATE = "GET_CLASS_CERTIFICATE"

export const GET_LIST_TYPES_CERTIFICATES = "GET_LIST_TYPES_CERTIFICATES"
export const IS_LOADING_GET_LIST_TYPE_CERTIFICATE = "IS_LOADING_GET_LIST_TYPE_CERTIFICATE"
export const ADD_TYPE_CERTIFICATE = "ADD_TYPE_CERTIFICATE"
export const GET_TYPE_CERTIFICATE = "GET_TYPE_CERTIFICATE"
export const EDIT_TYPE_CERTIFICATE = "EDIT_TYPE_CERTIFICATE"
export const DELETE_TYPE_CERTIFICATE = "DELETE_TYPE_CERTIFICATE"

export const IS_LOADING_LIST_STATE_CONCEPT_CERTIFICATE = "IS_LOADING_LIST_STATE_CONCEPT_CERTIFICATE"
export const GET_LIST_STATE_CONCEPT_CERTIFICATE = "GET_LIST_STATE_CONCEPT_CERTIFICATE"
export const CHANGE_STATE_CONCEPT_CERTIFICATE = "CHANGE_STATE_CONCEPT_CERTIFICATE"
export const IS_LOADING_LIST_CONCEPT_CERTIFICATE = "IS_LOADING_LIST_CONCEPT_CERTIFICATE"
export const GET_LIST_CONCEPT_CERTIFICATE = "GET_LIST_CONCEPT_CERTIFICATE"

export const GET_LIST_MARK_TYPE = "GET_LIST_MARK_TYPE"
export const ADD_MARK_TYPE = "ADD_MARK_TYPE"
export const EDIT_MARK_TYPE = "EDIT_MARK_TYPE"
export const IS_LOADING_GET_LIST_MARK_TYPE = "IS_LOADING_GET_LIST_MARK_TYPE"
export const DELETE_MARK_TYPE = "DELETE_MARK_TYPE"
export const GET_MARK_TYPE = "GET_MARK_TYPE"

export const GET_LIST_CHAT_CATEGORIES = "GET_LIST_CHAT_CATEGORIES"
export const CREATE_CHAT_CATEGORIE = "CREATE_CHAT_CATEGORIE"
export const EDIT_CHAT_CATEGORIE = "EDIT_CHAT_CATEGORIE"
export const IS_LOADING_GET_LIST_CHAT_CATEGORIES = "IS_LOADING_GET_LIST_CHAT_CATEGORIES"
export const DELETE_CHAT_CATEGORY = "DELETE_CHAT_CATEGORY"
export const GET_CHAT_CATEGORY = "GET_CHAT_CATEGORY"


export const CREATE_POINT_PACKAGE = "CREATE_POINT_PACKAGE"
export const EDIT_POINT_PACKAGE = "EDIT_POINT_PACKAGE"
export const IS_LOADING_CREATE_POINT_PACKAGE = "IS_LOADING_CREATE_POINT_PACKAGE"
export const IS_LOADING_POINT_PACKAGES = "IS_LOADING_POINT_PACKAGES"
export const LIST_OF_POINT_PACKAGES = "LIST_OF_POINT_PACKAGES"
export const DELETE_POINT_PACKAGE = "DELETE_POINT_PACKAGE"
export const GET_POINT_PACKAGE_INFO = "GET_POINT_PACKAGE_INFO"


export const IS_LOADING_GET_LIST_COMMUNITY_CATEGORIES = "IS_LOADING_GET_LIST_COMMUNITY_CATEGORIES"
export const CREATE_COMMUNITY_CATEGORIE = "CREATE_COMMUNITY_CATEGORIE"
export const EDIT_COMMUNITY_CATEGORIE = "EDIT_COMMUNITY_CATEGORIE"
export const GET_LIST_COMMUNITY_CATEGORIES = "GET_LIST_COMMUNITY_CATEGORIES"
export const GET_COMMUNITY_CATEGORY = "GET_COMMUNITY_CATEGORY"
export const DELETE_COMMUNITY_CATEGORY = "DELETE_COMMUNITY_CATEGORY"

export const DELETE_PERMISSION = "DELETE_PERMISSION"
export const GET_PERMISSION_INFO = "GET_PERMISSION_INFO"
export const CREATE_PERMISSION = "CREATE_PERMISSION"
export const EDIT_PERMISSION = "EDIT_PERMISSION"
export const IS_LOADING_ACTIVE_PERMISSION_LIST = "IS_LOADING_ACTIVE_PERMISSION_LIST"
export const ACTIVE_PERMISSION_LIST = "ACTIVE_PERMISSION_LIST"
export const IS_LOADING_INACTIVE_PERMISSION_LIST = "IS_LOADING_INACTIVE_PERMISSION_LIST"
export const INACTIVE_PERMISSION_LIST = "INACTIVE_PERMISSION_LIST"
export const CHANGE_TO_INACTIVE_PERMISSION = "CHANGE_TO_INACTIVE_PERMISSION"
export const CHANGE_TO_ACTIVE_PERMISSION = "CHANGE_TO_ACTIVE_PERMISSION"


export const DELETE_TYPE_MANAGER = "DELETE_TYPE_MANAGER"
export const CREATE_TYPE_MANAGER = "CREATE_TYPE_MANAGER"
export const GET_TYPE_MANAGER_INFO = "GET_TYPE_MANAGER_INFO"
export const EDIT_TYPE_MANAGER = "EDIT_TYPE_MANAGER"
export const IS_LOADING_ACTIVE_TYPE_MANAGER_LIST = "IS_LOADING_ACTIVE_TYPE_MANAGER_LIST"
export const ACTIVE_TYPE_MANAGER_LIST = "ACTIVE_TYPE_MANAGER_LIST"
export const IS_LOADING_INACTIVE_TYPE_MANAGER_LIST = "IS_LOADING_INACTIVE_TYPE_MANAGER_LIST"
export const INACTIVE_TYPE_MANAGER_LIST = "INACTIVE_TYPE_MANAGER_LIST"
export const CHANGE_TO_ACTIVE_TYPE_MANAGER = "CHANGE_TO_ACTIVE_TYPE_MANAGER"
export const CHANGE_TO_INACTIVE_TYPE_MANAGER = "CHANGE_TO_INACTIVE_TYPE_MANAGER"

export const IS_LOADING_BANE_LIMITS = "IS_LOADING_BANE_LIMITS"
export const CREATE_BANE_LIMIT = "CREATE_BANE_LIMIT"
export const DELETE_BANE_LIMIT = "DELETE_BANE_LIMIT"
export const GET_BAN_LIMIT_LIST = "GET_BAN_LIMIT_LIST"
export const GET_ACTUAL_LIMIT_BANE = "GET_ACTUAL_LIMIT_BANE"
export const GET_LIMIT_BANE = "GET_LIMIT_BANE"
export const EDIT_BANE_LIMIT = "EDIT_BANE_LIMIT"
export const ACTUAL_BANE_LIMIT = "ACTUAL_BANE_LIMIT"

export const EDIT_GENERAL_LIMIT = "EDIT_GENERAL_LIMIT"
export const IS_LOADING_LIMITS_LIST = "IS_LOADING_LIMITS_LIST"
export const CREATE_GENERAL_LIMIT = "CREATE_GENERAL_LIMIT"
export const DELETE_LIMIT = "DELETE_LIMIT"
export const ADD_LIMIT = "ADD_LIMIT"
export const EDIT_LIMIT = "EDIT_LIMIT"
export const GET_LIST_LIMIT = "GET_LIST_LIMIT"

export const IS_LOADING_LIST_REPORTS = "IS_LOADING_LIST_REPORTS"
export const LIST_REPORTS = "LIST_REPORTS"
export const ClEAN_LIST_REPORTS = "ClEAN_LIST_REPORTS"
export const CHANGE_REPORT = "CHANGE_REPORT"

export const IS_LOADING_LIST_REPORTS_CONTENT = "IS_LOADING_LIST_REPORTS_CONTENT"
export const LIST_REPORTS_CONTENT = "LIST_REPORTS_CONTENT"
export const CHANGE_REPORT_CONTENT = "CHANGE_REPORT_CONTENT"


export const IS_LOADING_ACTION_AWARDS = "IS_LOADING_ACTION_AWARDS"
export const IS_ERROR_ACTION_AWARDS = "IS_ERROR_ACTION_AWARDS"
export const UPDATE_ACTION_AWARD = "UPDATE_ACTION_AWARD"
export const CREATE_ACTION_AWARD = "CREATE_ACTION_AWARD"
export const GET_RANK_AVANCE = "GET_RANK_AVANCE"
export const GET_ACTION_AWARD_INFO = "GET_ACTION_AWARD_INFO"
export const DELETE_ACTION_AWARD_INFO = "DELETE_ACTION_AWARD_INFO"
export const ACTION_AWARD_LIST = "ACTION_AWARD_LIST"

export const IS_LOADING_CHALLENGE_AWARDS = "IS_LOADING_CHALLENGE_AWARDS"
export const CREATE_CHALLENGE_AWARD = "CREATE_CHALLENGE_AWARD"
export const UPDATE_CHALLENGE_AWARD = "UPDATE_CHALLENGE_AWARD"
export const DELETE_CHALLENGE_AWARD = "DELETE_CHALLENGE_AWARD"
export const CHALLENGE_AWARD_LIST = "CHALLENGE_AWARD_LIST"
export const GET_CHALLENGE_AWARD_INFO = "GET_CHALLENGE_AWARD_INFO"

export const IS_LOADING_TYPES_OF_AWARDS = "IS_LOADING_TYPES_OF_AWARDS"
export const CREATE_TYPE_OF_AWARD = "CREATE_TYPE_OF_AWARD"
export const UPDATE_TYPE_OF_AWARDS = "UPDATE_TYPE_OF_AWARDS"
export const DELETE_TYPE_OF_AWARD = "DELETE_TYPE_OF_AWARD"
export const TYPES_OF_AWARDS_LIST = "TYPES_OF_AWARDS_LIST"
export const GET_TYPE_OF_AWARD_INFO = "GET_TYPE_OF_AWARD_INFO"

export const IS_LOADING_AWARDS = "IS_LOADING_AWARDS"
export const CREATE_AWARD = "CREATE_AWARD"
export const UPDATE_AWARDS = "UPDATE_AWARDS"
export const DELETE_AWARD = "DELETE_AWARD"
export const AWARDS_LIST = "AWARDS_LIST"
export const GET_AWARD_INFO = "GET_AWARD_INFO"

export const IS_LOADING_GET_LIST_CLASSIFIED_CATEGORIES = "IS_LOADING_GET_LIST_CLASSIFIED_CATEGORIES"
export const ADD_CLASSIFIED_CATEGORIE = "ADD_CLASSIFIED_CATEGORIE"
export const GET_LIST_CLASSIFIED_CATEGORIES = "GET_LIST_CLASSIFIED_CATEGORIES"
export const GET_CLASSIFIED_CATEGORY = "GET_CLASSIFIED_CATEGORY"
export const EDIT_CLASSIFIED_CATEGORY = "EDIT_CLASSIFIED_CATEGORY"
export const DELETE_CLASSIFIED_CATEGORY = "DELETE_CLASSIFIED_CATEGORY"

export const IS_LOADING_GET_LIST_CLASSIFIED_SUBCATEGORIES = "IS_LOADING_GET_LIST_CLASSIFIED_SUBCATEGORIES"
export const ADD_CLASSIFIED_SUBCATEGORIE = "ADD_CLASSIFIED_SUBCATEGORIE"
export const GET_LIST_CLASSIFIED_SUBCATEGORIES = "GET_LIST_CLASSIFIED_SUBCATEGORIES"
export const GET_CLASSIFIED_SUBCATEGORY = "GET_CLASSIFIED_SUBCATEGORY"
export const EDIT_CLASSIFIED_SUBCATEGORY = "EDIT_CLASSIFIED_SUBCATEGORY"
export const DELETE_CLASSIFIED_SUBCATEGORY = "DELETE_CLASSIFIED_SUBCATEGORY"

export const IS_LOADING_GET_LIST_CLASSIFIED_STATUS = "IS_LOADING_GET_LIST_CLASSIFIED_STATUS"
export const ADD_CLASSIFIED_STATUS = "ADD_CLASSIFIED_STATUS"
export const GET_LIST_CLASSIFIED_STATUS = "GET_LIST_CLASSIFIED_STATUS"
export const EDIT_CLASSIFIED_STATUS = "EDIT_CLASSIFIED_STATUS"
export const DELETE_CLASSIFIED_STATUS = "DELETE_CLASSIFIED_STATUS"
export const GET_CLASSIFIED_STATUS = "GET_CLASSIFIED_STATUS"

export const IS_LOADING_PERMISSION_LIST_ADMIN = "IS_LOADING_PERMISSION_LIST_ADMIN"
export const PERMISSION_LIST_ADMIN = "PERMISSION_LIST_ADMIN"
export const CREATE_PERMISSION_ADMIN="CREATE_PERMISSION_ADMIN"
export const DELETE_PERMISSION_ADMIN = "DELETE_PERMISSION_ADMIN"
export const EDIT_PERMISSION_ADMIN = "EDIT_PERMISSION_ADMIN"
export const GET_PERMISSION_INFO_ADMIN = "GET_PERMISSION_INFO_ADMIN"

export const IS_LOADING_ROLES_LIST_ADMIN = "IS_LOADING_ROLES_LIST_ADMIN"
export const ROLE_LIST_ADMIN = "ROLE_LIST_ADMIN"
export const CREATE_ROLE_ADMIN = "CREATE_ROLE_ADMIN"
export const EDIT_ROLE_ADMIN = "EDIT_ROLE_ADMIN"
export const DELETE_ROLE_ADMIN = "DELETE_ROLE_ADMIN"
export const GET_ROLE_INFO = "GET_ROLE_INFO"

export const IS_LOADING_LIST_ADMIN = "IS_LOADING_LIST_ADMIN"
export const CREATE_ADMIN = "CREATE_ADMIN"
export const EDIT_ADMIN = "EDIT_ADMIN"
export const DELETE_ADMIN = "DELETE_ADMIN"
export const GET_ADMIN_INFO = "GET_ADMIN_INFO"
export const GET_MY_ADMIN_INFO = "GET_MY_ADMIN_INFO"
export const LIST_ADMIN = "LIST_ADMIN"


export const IS_LOADING_GET_LIST_PROFESSIONAL_COMMUNITY_CATEGORIES = "IS_LOADING_GET_LIST_PROFESSIONAL_COMMUNITY_CATEGORIES"
export const CREATE_PROFESSIONAL_COMMUNITY_CATEGORIE = "CREATE_PROFESSIONAL_COMMUNITY_CATEGORIE"
export const GET_LIST_PROFESSIONAL_COMMUNITY_CATEGORIES = "GET_LIST_PROFESSIONAL_COMMUNITY_CATEGORIES"
export const GET_PROFESSIONAL_COMMUNITY_CATEGORY = "GET_PROFESSIONAL_COMMUNITY_CATEGORY"
export const EDIT_PROFESSIONAL_COMMUNITY_CATEGORIE = "EDIT_PROFESSIONAL_COMMUNITY_CATEGORIE"
export const DELETE_PROFESSIONAL_COMMUNITY_CATEGORY = "DELETE_PROFESSIONAL_COMMUNITY_CATEGORY"

export const IS_LOADING_ACTIVE_PROFESSIONAL_PERMISSION_LIST = "IS_LOADING_ACTIVE_PROFESSIONAL_PERMISSION_LIST"
export const CREATE_PROFESSIONAL_PERMISSION = "CREATE_PROFESSIONAL_PERMISSION"
export const DELETE_PROFESSIONAL_PERMISSION = "DELETE_PROFESSIONAL_PERMISSION"
export const IS_LOADING_INACTIVE_PROFESSIONAL_PERMISSION_LIST = "IS_LOADING_INACTIVE_PROFESSIONAL_PERMISSION_LIST"
export const EDIT_PROFESSIONAL_PERMISSION = "EDIT_PROFESSIONAL_PERMISSION"
export const CHANGE_TO_ACTIVE_PROFESSIONAL_PERMISSION = "CHANGE_TO_ACTIVE_PROFESSIONAL_PERMISSION"
export const CHANGE_TO_INACTIVE_PROFESSIONAL_PERMISSION = "CHANGE_TO_INACTIVE_PROFESSIONAL_PERMISSION"
export const GET_PROFESSIONAL_PERMISSION_INFO = "GET_PROFESSIONAL_PERMISSION_INFO"
export const ACTIVE_PROFESSIONAL_PERMISSION_LIST = "ACTIVE_PROFESSIONAL_PERMISSION_LIST"
export const INACTIVE_PROFESSIONAL_PERMISSION_LIST = "INACTIVE_PROFESSIONAL_PERMISSION_LIST"


export const IS_LOADING_ACTIVE_ROLE_PROFESSIONAL_COMMUNITY_LIST = "IS_LOADING_ACTIVE_ROLE_PROFESSIONAL_COMMUNITY_LIST"
export const CREATE_ROLE_PROFESSIONAL_COMMUNITY = "CREATE_ROLE_PROFESSIONAL_COMMUNITY"
export const EDIT_ROLE_PROFESSIONAL_COMMUNITY = "EDIT_ROLE_PROFESSIONAL_COMMUNITY"
export const IS_LOADING_INACTIVE_ROLE_PROFESSIONAL_COMMUNITY_LIST = "IS_LOADING_INACTIVE_ROLE_PROFESSIONAL_COMMUNITY_LIST"
export const CHANGE_TO_ACTIVE_ROLE_PROFESSIONAL_COMMUNITY = "CHANGE_TO_ACTIVE_ROLE_PROFESSIONAL_COMMUNITY"
export const CHANGE_TO_INACTIVE_ROLE_PROFESSIONAL_COMMUNITY = "CHANGE_TO_INACTIVE_ROLE_PROFESSIONAL_COMMUNITY"
export const DELETE_ROLE_PROFESSIONAL_COMMUNITY = "DELETE_ROLE_PROFESSIONAL_COMMUNITY"
export const GET_ROLE_PROFESSIONAL_COMMUNITY_INFO = "GET_ROLE_PROFESSIONAL_COMMUNITY_INFO"
export const ACTIVE_ROLE_PROFESSIONAL_COMMUNITY_LIST = "ACTIVE_ROLE_PROFESSIONAL_COMMUNITY_LIST"
export const INACTIVE_ROLE_PROFESSIONAL_COMMUNITY_LIST = "INACTIVE_ROLE_PROFESSIONAL_COMMUNITY_LIST"

export const IS_LOADING_LIST_PQRS_ADMIN = "IS_LOADING_LIST_PQRS_ADMIN"
export const LIST_PQRS_ADMIN = "LIST_PQRS_ADMIN"
export const IS_LOADING_RESPONSE_PQRS_ADMIN = "IS_LOADING_RESPONSE_PQRS_ADMIN"
export const RESPONSE_PQRS_ADMIN = "RESPONSE_PQRS_ADMIN"
export const DISABLE_PQRS_ADMIN = "DISABLE_PQRS_ADMIN"


export const IS_LOADING_LIST_OF_COLORS_REACTIONS = "IS_LOADING_LIST_OF_COLORS_REACTIONS"
export const CREATE_COLOR_REACTION = "CREATE_COLOR_REACTION"
export const LIST_OF_COLORS_REACTIONS = "LIST_OF_COLORS_REACTIONS"
export const EDIT_COLOR_REACTION = "EDIT_COLOR_REACTION"
export const DELETE_COLOR_REACTION = "DELETE_COLOR_REACTION"
export const IS_LOADING_COLOR_REACTION = "IS_LOADING_COLOR_REACTION"
export const COLOR_REACTION_INFO = "COLOR_REACTION_INFO"

export const IS_LOADING_LIST_REPORTS_COMMUNITIES = "IS_LOADING_LIST_REPORTS_COMMUNITIES"
export const LIST_REPORTS_COMMUNITIES = "LIST_REPORTS_COMMUNITIES"
export const CHANGE_REPORT_COMMUNITY = "CHANGE_REPORT_COMMUNITY"

export const IS_LOADING_RANKS = "IS_LOADING_RANKS"
export const CREATE_RANK ="CREATE_RANK"
export const UPDATE_RANK = "UPDATE_RANK"
export const DELETE_RANK = "DELETE_RANK"
export const RANKS_LIST = "RANKS_LIST"
export const GET_RANK_INFO = "GET_RANK_INFO"


    // Types para obtener todos los productos de las franquicias
  export const GET_ALL_PRODUCTS_FRANCHISE = "GET_ALL_PRODUCTS_FRANCHISE"
  export const LOADING_ALL_PRODUCTS_FRANCHISE = "LOADING_ALL_PRODUCTS_FRANCHISE"
  export const ERROR_ALL_PRODUCTS_FRANCHISE = "ERROR_ALL_PRODUCTS_FRANCHISE"
  
    // Types para obtener todos los productos deL propietario
  export const  GET_ALL_PRODUCTS_OWNER = "GET_ALL_PRODUCTS_OWNER"
  export const  LOADING_ALL_PRODUCTS_OWNER = "LOADING_ALL_PRODUCTS_OWNER"
  export const  ERROR_ALL_PRODUCTS_OWNER = "ERROR_ALL_PRODUCTS_OWNER"
  
    //Types para obtener las franquicias
  export const  GET_ALL_FRANCHIES = "GET_ALL_FRANCHIES"
  export const  LOADING_ALL_FRANCHIES = "LOADING_ALL_FRANCHIES"
  export const  ERROR_ALL_FRANCHIES = "ERROR_ALL_FRANCHIES"
  
    //Types para crear Bodega
  export const  CREATE_STORE_LOADING = "CREATE_STORE_LOADING"
  export const  CREATE_STORE_SUCCESS = "CREATE_STORE_SUCCESS"
  export const  CREATE_STORE_ERROR = "CREATE_STORE_ERROR"
  
    //Types para obtener una sola bodega
  export const  GET_ONLY_ONE_STORE = "GET_ONLY_ONE_STORE"
  export const  LOADING_ONLY_ONE_STORE = "LOADING_ONLY_ONE_STORE"
  export const  ERROR_ONLY_ONE_STORE = "ERROR_ONLY_ONE_STORE"
  
    //Types paras obtener todas las bodegas
  export const  GET_ALL_STORE = "GET_ALL_STORE"
  export const  LOADING_ALL_STORE = "LOADING_ALL_STORE"
  export const  ERROR_ALL_STORE = "ERROR_ALL_STORE"
  
    //Types para actualizar la bodega
  export const  UPDATE_STORE = "UPDATE_STORE"
  export const  LOADING_UPDATE_STORE = "LOADING_UPDATE_STORE"
  export const  ERROR_UPDATE_STORE = "ERROR_UPDATE_STORE"
  
    //Types para borrar la bodega
  export const  DELETE_STORE = "UPDATE_STORE"
  export const  LOADING_DELETE_STORE = "LOADING_DELETE_STORE"
  export const  ERROR_DELETE_STORE = "ERROR_DELETE_STORE"
  
  
    //Types para obtener una sola bodega
  export const  GET_ONLY_ONE_SUB_STOR = "GET_ONLY_ONE_STORE"
  export const  LOADING_ONLY_ONE_SUB_STORE = "LOADING_ONLY_ONE_STORE"
  export const  ERROR_ONLY_ONE_SUB_STORE = "ERROR_ONLY_ONE_STORE"
  
    //Types paras obtener todas las bodegas
  export const  GET_ALL_SUB_STORE = "GET_ALL_SUB_STORE"
  export const  LOADING_ALL_SUB_STORE = "LOADING_ALL_SUB_STORE"
  export const  ERROR_ALL_SUB_STORE ="ERROR_ALL_SUB_STORE"
  
    //Types para actualizar la bodega
  export const  UPDATE_SUB_STORE = "UPDATE_SUB_STORE"
  export const  LOADING_UPDATE_SUB_STORE ="LOADING_UPDATE_SUB_STORE"
  export const  ERROR_UPDATE_SUB_STORE = "ERROR_UPDATE_SUB_STORE"
  
    //Types para borrar la bodega
  export const  DELETE_SUB_STORE = "UPDATE_SUB_STORE"
  export const  LOADING_DELETE_SUB_STORE ="LOADING_DELETE_SUB_STORE"
  export const  ERROR_DELETE_SUB_STORE = "ERROR_DELETE_SUB_STORE"
  
    //Types para crear Almacen
  export const  CREATE_WAREHOUSE_LOADING = "CREATE_WAREHOUSE_LOADING"
  export const  CREATE_WAREHOUSE_SUCCESS = "CREATE_WAREHOUSE_SUCCESS"
  export const  CREATE_WAREHOUSE_ERROR = "CREATE_WAREHOUSE_ERROR"
  
    //Types para obtener una sola bodega
  export const  GET_ONLY_ONE_WAREHOUSE = "GET_ONLY_ONE_WAREHOUSE"
  export const  LOADING_ONLY_ONE_WAREHOUSE = "LOADING_ONLY_ONE_WAREHOUSE"
  export const  ERROR_ONLY_ONE_WAREHOUSE = "ERROR_ONLY_ONE_WAREHOUSE"
  
    //Types paras obtener todas las bodegas
  export const  GET_ALL_WAREHOUSE = "GET_ALL_WAREHOUSE"
  export const  LOADING_ALL_WAREHOUSE = "LOADING_ALL_WAREHOUSE"
  export const  ERROR_ALL_WAREHOUSE = "ERROR_ALL_WAREHOUSE"
  
    //Types para actualizar la bodega
  export const  UPDATE_WAREHOUSE = "UPDATE_WAREHOUSE"
  export const  LOADING_UPDATE_WAREHOUSE = "LOADING_UPDATE_WAREHOUSE"
  export const  ERROR_UPDATE_WAREHOUSE = "ERROR_UPDATE_WAREHOUSE"
  
    //Types para borrar la bodega
  export const  DELETE_WAREHOUSE = "UPDATE_WAREHOUSE"
  export const  LOADING_DELETE_WAREHOUSE = "LOADING_DELETE_WAREHOUSE"
  export const  ERROR_DELETE_WAREHOUSE = "ERROR_DELETE_WAREHOUSE"
  
  
    //Types para crear representantes
  export const  CREATE_REPRESENTATIVES_LOADING = "CREATE_REPRESENTATIVES_LOADING"
  export const  CREATE_REPRESENTATIVES_SUCCESS = "CREATE_REPRESENTATIVES_SUCCESS"
  export const  CREATE_REPRESENTATIVES_ERROR = "CREATE_REPRESENTATIVES_ERROR"
    
    //Type crear franquisiado
  export const  CREATE_FRANCHISE_SUCCESS = "CREATE_FRANCHISE_SUCCESS"
  export const  CREATE_FRANCHISE_LOADING = "CREATE_FRANCHISE_LOADING"
  export const  CREATE_FRANCHISE_ERROR = "CREATE_FRANCHISE_ERROR"
  
    //Type editar franquisiado
  export const  EDIT_FRANCHISE_SUCCESS = "EDIT_FRANCHISE_SUCCESS"
  export const  EDIT_FRANCHISE_LOADING = "EDIT_FRANCHISE_LOADING"
  export const  EDIT_FRANCHISE_ERROR = "EDIT_FRANCHISE_ERROR"
  
    //Types para crear representantes
  export const  UPLOAD_FILE_LOADING = "UPLOAD_FILE_LOADING"
  export const  UPLOAD_FILE_SUCCESS = "UPLOAD_FILE_SUCCESS"
  export const  UPLOAD_FILE_ERROR = "UPLOAD_FILE_ERROR"
  
  

  

export const IS_LOADING_PRODUCT = "IS_LOADING_PRODUCT"
export const GET_PRODUCT = "GET_PRODUCT"
export const IS_LOADING_PRODUCTS = "IS_LOADING_PRODUCTS"
export const LIST_OF_PRODUCTS = "LIST_OF_PRODUCTS"
export const IS_LOADING_REPORT_BY_TYPE = "IS_LOADING_REPORT_BY_TYPE"
export const REPORT_BY_TYPE = "REPORT_BY_TYPE"
export const IS_LOADING_UTILITY_REPORT = "IS_LOADING_UTILITY_REPORT"
export const UTILITY_REPORT = "UTILITY_REPORT"

export const CREATE_PRODUCT = "CREATE_PRODUCT"
export const EDIT_PRODUCT = "EDIT_PRODUCT"
export const DELETE_PRODUCT = "DELETE_PRODUCT"

export const ERROR_PRODUCT = "ERROR_PRODUCT"

export const LIST_OF_PRODUCTS_PRESENTATIONS= "LIST_OF_PRODUCTS_PRESENTATIONS"
export const CREATE_PRODUCTS_PRESENTATIONS= "CREATE_PRODUCTS_PRESENTATIONS"
export const EDIT_PRODUCTS_PRESENTATIONS= "EDIT_PRODUCTS_PRESENTATIONS"
export const DELETE_PRODUCTS_PRESENTATIONS= "DELETE_PRODUCTS_PRESENTATIONS"

export const IS_LOADING_WINERIES = "IS_LOADING_WINERIES"
export const LIST_OF_WINERIES = "LIST_OF_WINERIES"
export const DELETE_WINERY = "DELETE_WINERY"
export const EDIT_WINERY = "EDIT_WINERY"
export const CREATE_WINERY= "CREATE_WINERY"
export const ERROR_WINERY = "ERROR_WINERY"
export const IS_LOADING_DELETE_WINERIES = "IS_LOADING_DELETE_WINERIES"
export const IS_LOADING_UPDATE_WINERIES = "IS_LOADING_UPDATE_WINERIES"
export const GET_ONLY_ONE_WINERY = "GET_ONLY_ONE_WINERY"
export const IS_LOADING_ONLY_WINERY = "IS_LOADING_ONLY_WINERY"

//Types para crear Sub Bodega
export const CREATE_SUB_WINERY_SUCCESS ="CREATE_SUB_WINERY_SUCCESS"
export const IS_LOADING_CREATE_SUB_WINERY = "IS_LOADING_CREATE_SUB_WINERY"
export const IS_LOADING_DELETE_SUB_WINERY = "IS_LOADING_DELETE_SUB_WINERY"
export const IS_LOADING_LIST_SUB_WINERIES = "IS_LOADING_LIST_SUB_WINERIES"
export const IS_LOADING_UPDATE_SUB_WINERIES = "IS_LOADING_UPDATE_SUB_WINERIES"
export const LIST_OF_SUB_WINERIES = "LIST_OF_SUB_WINERIES"
export const DELETE_SUB_WINERY_SUCCESS ="DELETE_SUB_WINERY_SUCCESS"
export const EDIT_SUB_WINERY_SUCCESS = "EDIT_SUB_WINERY_SUCCESS"
export const GET_ONLY_ONE_SUB_WINERY = "GET_ONLY_ONE_SUB_WINERY"
export const IS_LOADING_ONLY_SUB_WINERY = "IS_LOADING_ONLY_SUB_WINERY"
export const IS_LOADING_SUBWINERIES_BY_NAME = "IS_LOADING_SUBWINERIES_BY_NAME"
export const LIST_OF_SUBWINERIES_BY_NAME = "LIST_OF_SUBWINERIES_BY_NAME"
export const CLEAR_SUB_WINERIES = "CLEAR_SUB_WINERIES"

export const IS_WINERY_BATCHES = "IS_WINERY_BATCHES"
export const LIST_OF_WINERY_BATCHES  = "LIST_OF_WINERY_BATCHES"
export const DELETE_WINERY_BATCHES  = "DELETE_WINERY_BATCHES"
export const EDIT_WINERY_BATCHES  = "EDIT_WINERY_BATCHES"
export const CREATE_WINERY_BATCHES  = "CREATE_WINERY_BATCHES"
export const ERROR_WINERY_BATCHES = "ERROR_WINERY_BATCHES"

export const IS_LOADING_GET_AUTH_REQUEST = "IS_LOADING_GET_AUTH"
export const GET_AUTH_REQUEST = "GET_AUTH_REQUEST"
export const IS_LOADING_GET_AUTH_REQUEST_BY_ID = "IS_LOADING_GET_AUTH_REQUEST_BY_ID"
export const GET_AUTH_REQUEST_BY_ID = "GET_AUTH_REQUEST_BY_ID"
export const IS_LOADING_CHANGE_STATE = "IS_LOADING_CHANGE_STATE"
export const CHANGE_AUTH_STATE = "CHANGE_AUTH_STATE"

export const IS_LOADING_GET_PENDING_AUTH_FRANCHISE = "IS_LOADING_GET_PENDING_AUTH_FRANCHISE"
export const GET_PENDING_AUTH_FRANCHISE = "GET_PENDING_AUTH_FRANCHISE"
export const IS_LOADING_AUTH_FRANCHISE_BY_ID = "IS_LOADING_AUTH_FRANCHISE_BY_ID"
export const AUTH_FRANCHISE_BY_ID = "AUTH_FRANCHISE_BY_ID"
export const IS_LOADING_CHANGE_STATE_FRAN = "IS_LOADING_CHANGE_STATE_FRAN"
export const CHANGE_FRANCHISE_STATE = "CHANGE_FRANCHISE_STATE"

export const LOADING_REPRESENTATIVE_REQUEST = "LOADING_REPRESENTATIVE_REQUEST"
export const REPRESENTATIVE_REQUEST_SUCCESS = "REPRESENTATIVE_REQUEST_SUCCESS"
export const LOADING_REPRESENTATIVE_REQUEST_BY_ID = "LOADING_REPRESENTATIVE_REQUEST_BY_ID"
export const AUTH_REPRESENTATIVE_BY_ID_SUCCESS = "AUTH_REPRESENTATIVE_BY_ID_SUCCESS"
export const LOADING_CHANGE_STATE_REPRE = "LOADING_CHANGE_STATE_REPRE"
export const CHANGE_REPRESENTATIVE_STATE = "CHANGE_REPRESENTATIVE_STATE"

export const CREATE_ADMIN_CAMPAIGNS = "CREATE_ADMIN_CAMPAIGNS"
export const LOADING_CREATE_ADMIN_CAMPAING = "LOADING_CREATE_ADMIN_CAMPAING"
export const LOADING_GET_ALL_ADMIN_CAMPAING = "LOADING_GET_ALL_ADMIN_CAMPAING"
export const GET_ALL_ADMIN_CAMPAING = "GET_ALL_ADMIN_CAMPAING"
export const DELETE_ADMIN_CAMPAING = "DELETE_ADMIN_CAMPAING"
export const LOADING_DELETE_ADMIN_CAMPAING = "LOADING_DELETE_ADMIN_CAMPAING"
export const LOADING_UPDATE_ADMIN_CAMPAING = "LOADING_UPDATE_ADMIN_CAMPAING"
export const UPDATE_ADMIN_CAMPAING = "UPDATE_ADMIN_CAMPAING"
export const LOADING_GET_ADMIN_CAMPAING_BY_ID = "LOADING_GET_ADMIN_CAMPAING_BY_ID"
export const GET_ADMIN_CAMPAING_BY_ID = "GET_ADMIN_CAMPAING_BY_ID"



export const ADD_TO_TRANSFER_CART= "ADD_TO_TRANSFER_CART"
export const SET_PRODUCT_TO_TRANSFER_CART= "SET_PRODUCT_TO_TRANSFER_CART"
export const SET_QUANTITY_TO_TRANSFER_CART= "SET_QUANTITY_TO_TRANSFER_CART"
export const ADD_TO_PENDING_ORDERS= "ADD_TO_PENDING_ORDERS"
export const GET_PENDING_ORDER_BY_ID = "GET_PENDING_ORDER_BY_ID"

export const ADD_SPECIFICATION = "ADD_SPECIFICATION"
export const CLEAR_SPECIFICATION = "CLEAR_SPECIFICATION"
export const ADD_SPECIFICATION_DEVOLUTION = "ADD_SPECIFICATION_DEVOLUTION"
export const CLEAR_SPECIFICATION_DEVOLUTION = "CLEAR_SPECIFICATION_DEVOLUTION"
export const GET_PENDING_ORDERS = "GET_PENDING_ORDERS"
export const CLEAR_PENDING_ORDERS = "CLEAR_PENDING_ORDERS"
export const CLEAR_TRANSFER_CART = "CLEAR_TRANSFER_CART"
export const GET_CONSOLIDATE_PRODUCTS = "GET_CONSOLIDATE_PRODUCTS"
export const IS_LOADING_BESTSELLER_PRODUCTS = "IS_LOADING_BESTSELLER_PRODUCTS"
export const GET_BESTSELLER_PRODUCTS = "GET_BESTSELLER_PRODUCTS"

export const CREATE_CATEGORY_PRODUCTS = "CREATE_CATEGORY_PRODUCTS"
export const EDIT_CATEGORY_PRODUCTS = "EDIT_CATEGORY_PRODUCTS"
export const LIST_CATEGORY_PRODUCTS = "LIST_CATEGORY_PRODUCTS"
export const IS_LOADING_LIST_COMPLETE_CATEGORY_PRODUCTS = "IS_LOADING_LIST_COMPLETE_CATEGORY_PRODUCTS"
export const LIST_COMPLETE_CATEGORY_PRODUCTS = "LIST_COMPLETE_CATEGORY_PRODUCTS"
export const DELETE_CATEGORY_PRODUCTS = "DELETE_CATEGORY_PRODUCTS"

export const CREATE_SUBCATEGORY_PRODUCTS = "CREATE_SUBCATEGORY_PRODUCTS"
export const EDIT_SUBCATEGORY_PRODUCTS = "EDIT_SUBCATEGORY_PRODUCTS"
export const LIST_SUBCATEGORY_PRODUCTS = "LIST_SUBCATEGORY_PRODUCTS"
export const DELETE_SUBCATEGORY_PRODUCTS = "DELETE_SUBCATEGORY_PRODUCTS"




